import { useEffect, useState } from "react"

import { OTP_SCRIPT } from "gatsby-env-variables"

import addScript from "@mobi/utils/browser/addScript"

const loadOtpScript = () => {
  return addScript(OTP_SCRIPT)
}
const useOtp = ({
  otpToken,
  hasDefaultButton,
  onContinue = () => {},
  onInvalid = () => {},
  setIsValid = () => {},
}) => {
  useEffect(() => {
    loadOtpScript()
    addListeners()
    return () => {
      removeListeners()
    }
  }, [])

  const addListeners = () => {
    window.addEventListener(`onOTPInvalid${otpToken}`, handleOnInvalid)

    window.addEventListener(`onOTPPostValidate${otpToken}`, handleOnContinue)

    if (!hasDefaultButton) {
      window.addEventListener(
        `onOTPEnableSubmitButton${otpToken}`,
        handleOtpEnableSubmitButton,
      )
      window.addEventListener(
        `onOTPDisableSubmitButton${otpToken}`,
        handleOtpDisableSubmitButton,
      )
    }
  }

  const removeListeners = () => {
    window.removeEventListener(`onOTPInvalid${otpToken}`, handleOnInvalid)
    window.removeEventListener(`onOTPPostValidate${otpToken}`, handleOnContinue)
    window.removeEventListener(
      `onOTPEnableSubmitButton${otpToken}`,
      handleOtpEnableSubmitButton,
    )
    window.removeEventListener(
      `onOTPDisableSubmitButton${otpToken}`,
      handleOtpDisableSubmitButton,
    )
  }

  const handleOnInvalid = (ev) => {
    onInvalid(ev)
  }

  const handleOnContinue = (ev) => {
    onContinue(ev)
  }

  const handleOtpEnableSubmitButton = () => {
    setIsValid(true)
  }

  const handleOtpDisableSubmitButton = () => {
    setIsValid(false)
  }

  return {}
}

export default useOtp
